import { useEffect, useState } from "react";
import { listOccurrenceTypes } from "@/services";
import { IOccurrenceType } from "@/interfaces/occurrenceTypes";

let cache: IOccurrenceType[] | null = null;
let inflight: Promise<IOccurrenceType[]> | null = null;

const fetchOccurrenceTypes = () => {
  if (!inflight) {
    inflight = listOccurrenceTypes({ limit: 500 })
      .then(({ occurrenceTypes }) => {
        cache = occurrenceTypes || [];
        return cache;
      })
      .catch((error) => {
        inflight = null; // permite nova tentativa no próximo mount
        throw error;
      });
  }
  return inflight;
};

/** Invalida o cache — chamar depois de criar, editar ou remover um tipo. */
export const invalidateOccurrenceTypesCatalog = () => {
  cache = null;
  inflight = null;
};

/**
 * Catalogo completo de tipos de ocorrencia, inativos inclusos — o AutoComplete precisa deles
 * para exibir o vinculo de registros antigos. Use activeOrSelected para montar as opcoes.
 */
export const useOccurrenceTypesCatalog = (): IOccurrenceType[] => {
  const [occurrenceTypes, setOccurrenceTypes] = useState<IOccurrenceType[]>(cache || []);

  useEffect(() => {
    if (cache) {
      setOccurrenceTypes(cache);
      return;
    }

    let active = true;
    fetchOccurrenceTypes()
      .then((items) => {
        if (active) setOccurrenceTypes(items);
      })
      .catch(() => {
        if (active) setOccurrenceTypes([]);
      });

    return () => {
      active = false;
    };
  }, []);

  return occurrenceTypes;
};

/** Opcoes de um campo de tipo: os ativos mais o tipo ja vinculado, ainda que desativado. */
export const activeOrSelected = (
  types: IOccurrenceType[],
  selectedId?: number | string | null,
): IOccurrenceType[] =>
  types.filter(
    (type) => type.isActive || (selectedId != null && String(type.id) === String(selectedId)),
  );
